/* global $, gsap, flatpickr, rangePlugin, Flickity: false */
// /* global slick: false */
// /* global isotope: false */

import { Tooltip } from './bootstrap.js';

( function() {
	'use strict';

} )();

// function InitReadMoreTogglers() {
// 	let readMoreToggle = $('.read-more-toggle');
// 	if (readMoreToggle.length > 0) {
// 		readMoreToggle.each(function() {
// 			$(this).readMoreToggler();
// 		});
// 	}
// }

function masonryGalleryInitialise() {
	let $gallery = $('.masonry-gallery');
	if ($gallery.length > 0) {
		if ($gallery.data('isotope')) {
			/**
			 * init Isotope after all images have loaded
			 */
			$gallery.imagesLoaded().progress( function(instance, image) {
				$gallery.isotope('layout');
			});

			/**
			 * Filter items on button click
			 */
			$('.masonry-gallery-filters').on('click', 'li a', function() {
				if (typeof preloader === 'function') {
					$gallery.find('.gallery-item').preloader({
						loader: '/app/themes/nelios-base/svg/loader/preloader.svg',
						fadeIn: 300,
						delay: 100
					});
				}

				$gallery.isotope({
					filter: $(this).attr('data-filter')
				});
			});
		} else if ($gallery.data('masonry')) {
			$gallery.imagesLoaded().progress( function() {
				$gallery.isotope('layout');
			});
		}
	}
}

$(document).ready( function() {
	'use strict';

	let fixedNavbar = $( '.fixed-navbar' );
	let mainNav;
	if ( fixedNavbar.length > 0 ) {
		let fixedNavbarPosition;
		if ( window.innerWidth > 991 ) {
			fixedNavbarPosition = fixedNavbar.offset().top;
		}
		else {
			mainNav = $('.main-navbar .sticky');
			fixedNavbarPosition = fixedNavbar.offset().top - mainNav.height();
		}

		$(window).on('scroll', function () {
			if ($(this).scrollTop() > fixedNavbarPosition) {
				fixedNavbar.addClass('fixed-top');
			} else {
				fixedNavbar.removeClass('fixed-top');
			}
		});
	}

	masonryGalleryInitialise();

	// Bootstrap 5.1 Tooltips
	let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
	tooltipTriggerList.map(function (tooltipTriggerEl) {
		tooltipTriggerEl.addEventListener('click', (ev) => {
			ev.preventDefault();
		});
		return new Tooltip(tooltipTriggerEl);
	});

	// InitReadMoreTogglers();

	let calculateVH = function() {
		const offset = window.innerWidth < 992 ? document.querySelector('.main-navbar .sticky').clientHeight : 0;
		const vh = (window.innerHeight - offset) * 0.01;

		Array.from(document.querySelectorAll('.vh')).forEach(function(el) {
			el.style.setProperty('--vh', vh + 'px');
		});
	};

	window.addEventListener('resize', () => {
		calculateVH();
	});

	window.addEventListener('mainMenu', (ev) => {
		if (ev.detail) {
			document.body.classList.add('main-menu-open');
		} else {
			document.body.classList.remove('main-menu-open');
		}
	});

	// Burger Button Functionality
	class BurgerButton {
		constructor(element = null) {
			this.buttonWrapper = element;
			this.button = this.buttonWrapper.querySelector('.burger-button') || false;
			this.events();
		}

		toggleButton() {
			this.buttonWrapper.classList.toggle('active');
			const mainMenuClicked = new CustomEvent('mainMenu', {detail: this.buttonWrapper.classList.contains('active')});
			window.dispatchEvent(mainMenuClicked);
		}

		events() {
			if (this.button) {
				this.buttonWrapper.addEventListener('click', this.toggleButton.bind(this), false);
			}
		}
	}
	let burgerButton = document.querySelector('.js-burger-button-wrapper');
	if (burgerButton) burgerButton = new BurgerButton(burgerButton);




	// Main Menu Functionality
	class MainMenu {
		constructor(element = null) {
			this.menu = element;
			this.secondSection = this.menu.querySelector('.js-second-section');
			this.isWorking = false;
			this.onKeyPressBind = this.onKeyPress.bind(this);
			this.events();
		}

		openMenu() {
			if (this.isWorking) return false;
			this.isWorking = true;

			gsap.set(this.menu, {x: 0, y: 0});

			let toOptions = {
				duration: 0.8,
				ease: 'power3.out',
				onComplete: () => {
					document.addEventListener('keyup', this.onKeyPressBind);
					this.isWorking = false;
					document.body.classList.remove('menu-is-working');
				}
			};

			if (window.innerWidth < 992) {
				toOptions.y = 0;
				gsap.fromTo(this.menu, {y: '-100%'}, toOptions);
			} else {
				toOptions.x = 0;
				gsap.fromTo(this.menu, {x: '-100%'}, toOptions);
				gsap.fromTo(this.secondSection, {x: '-100%'}, {x: 0, delay: 0.3, duration: 0.8, ease: 'power3.out'});
			}

			document.body.classList.add('menu-is-working');
		}

		closeMenu() {
			if (this.isWorking) return false;
			this.isWorking = true;

			gsap.set(this.menu, {x: 0, y: 0});

			let toOptions = {
				duration: 0.3,
				ease: 'power3.in',
				onComplete: () => {
					document.removeEventListener('keyup', this.onKeyPressBind);
					this.isWorking = false;
					document.body.classList.remove('menu-is-working');
				}
			};

			if (window.innerWidth < 992) {
				toOptions.y = '-100%';
				gsap.fromTo(this.menu, {y: 0}, toOptions);
			} else {
				toOptions.x = '-100%';
				// toOptions.delay = 0.05;
				gsap.to(this.secondSection, {x: '-100%', ease: 'power3.out', duration: 0.4});
				gsap.fromTo(this.menu, {x: 0}, toOptions);
			}

			document.body.classList.add('menu-is-working');
		}

		onKeyPress(ev) {
			if (ev.key === 'Escape') burgerButton.toggleButton();
		}

		menuListener(ev) {
			if (ev.detail) {
				this.openMenu.bind(this)();
			} else {
				this.closeMenu.bind(this)();
			}
		}

		events() {
			window.addEventListener('mainMenu', this.menuListener.bind(this), false);
		}
	}
	let mainMenu = document.querySelector('.js-primary-menu-wrapper') || false;
	if (mainMenu) mainMenu = new MainMenu(mainMenu);





	// Datepicker
	class DatePicker {
		constructor(checkInEl = null, checkOutEl = null) {
			if ( checkInEl && checkOutEl) {
				this.checkInEl = checkInEl;
				this.checkOutEl = checkOutEl;

				// flatpickr.l10ns.default.firstDayOfWeek = 1; // Monday
				// flatpickr.localize(flatpickr.l10ns.gr); // Use greek language

				flatpickr(this.checkInEl, {
					minDate: 'today',
					dateFormat: 'd-m-Y',
					plugins: [new rangePlugin({ input: checkOutEl})],
					disableMobile: 'true'
				});
			}
		}
	}
	let checkin = document.getElementById('checkin-picker');
	let checkout = document.getElementById('checkout-picker');

	if (checkin && checkout) {
		let checkinField = new DatePicker(checkin,checkout);
	}



	/* Flickity Slider Numbering */
	let listingRepeaterSlider = document.querySelectorAll('.listing-repeater.slideshow, .inner-slider.slideshow');
	Array.from(listingRepeaterSlider).forEach((slider) => {
		let flkty = Flickity.data(slider);
		flkty.on( 'change', function( index ) {
			slider.querySelector('.counter .counter-inner').innerHTML = index + 1;
		});
		flkty.on('dragStart', function () {
			this.cells.forEach((cell) => {
				cell.element.style.pointerEvents = 'none';
			});
		});
		flkty.on('dragEnd', function () {
			this.cells.forEach((cell) => {
				cell.element.style.pointerEvents = 'all';
			});
		});
	});



	/* ROOM NUMBER INPUTS */
	document.querySelectorAll('[data-numinput-target]').forEach((button) => {
		const input = document.getElementById(button.getAttribute('data-numinput-target'));
		const min = parseInt(input.getAttribute('min'));
		const max = parseInt(input.getAttribute('max'));
		const action = button.getAttribute('data-action');
		button.addEventListener('click', function () {
			let value = input.value ? parseInt(input.value) : min;
			if (action === 'incr' && value < max) {
				input.value = value + 1;
			} else if (action === 'decr' && value > min) {
				input.value = value - 1;
			}
		});
	});


	// Observer for is-clip-path effect
	const observer1 = new IntersectionObserver((entries) => {
		entries.map((entry, index) => {
			if (entry.isIntersecting) {
				setTimeout(() => {
					entry.target.classList.add('is-inview');
					observer1.unobserve(entry.target);
				}, 140 * index);
			}
		});
	}, {root: null, rootMargin: "0px 0px -100px 0px"});
	document.querySelectorAll('.is-clip-path').forEach(observable => observer1.observe(observable));


	// Observer for is-scale-up effect
	const observer2 = new IntersectionObserver((entries) => {
		entries.map((entry, index) => {
			if (entry.isIntersecting) {
				setTimeout(() => {
					entry.target.classList.add('is-inview');
					observer2.unobserve(entry.target);
				}, 140 * index);
			}
		});
	}, {threshold: .2});
	document.querySelectorAll('.is-scale-up').forEach(observable => observer2.observe(observable));


	// Observer for fade-in-me effect
	const observer3 = new IntersectionObserver((entries) => {
		entries.map((entry, index) => {
			if (entry.isIntersecting) {
				if (entry.target.classList.contains('fade-in-me')) {
					setTimeout(() => {
						entry.target.classList.add('is-inview');
						observer3.unobserve(entry.target);
					}, 140 * index);
				}
			}
		});
	}, {});
	document.querySelectorAll('.fade-in-me').forEach(observable => observer3.observe(observable));



	const splitting = Splitting();

	const wrapElements = (elems, wrapType, wrapClass) => {
		elems.forEach(char => {
			// add a wrap for every char (overflow hidden)
			const wrapEl = document.createElement(wrapType);
			wrapEl.classList = wrapClass;
			char.parentNode.appendChild(wrapEl);
			wrapEl.appendChild(char);
		});
	}

	let FXcurrentBreakpoint;
	const FXcalcWindowSize = () => {
		FXcurrentBreakpoint = getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-lg');
		return {width: window.innerWidth, height: window.innerHeight};
	};

	// Gets the mouse position
	const FXgetMousePos = e => {
		return {
			x : e.clientX,
			y : e.clientY
		};
	};

	const effect_wrapper = document.querySelectorAll('.move-effect-wrapper') || false;

	// Calculate the viewport size
	let FXwinsize = FXcalcWindowSize();
	if (window.innerWidth >= FXcurrentBreakpoint) {
		window.addEventListener('resize', () => FXwinsize = FXcalcWindowSize());
	}

	// Track the mouse position
	let FXmousepos = {x: FXwinsize.width/2, y: FXwinsize.height/2};
	if (window.innerWidth >= FXcurrentBreakpoint) {
		effect_wrapper.forEach((grid) => {
			grid.addEventListener('mousemove', ev => FXmousepos = FXgetMousePos(ev));
		});
	}

	class FXItem {
		constructor(el) {
			this.DOM = {el: el};
			this.invert = this.DOM.el.classList.contains('item--invert');
			this.DOM.enterAction = this.DOM.el;

			this.image = this.DOM.el.querySelector('.content-image');
			this.imageHelper = this.image.querySelector('.helper');

			this.editHeadingLayout();
			this.initEvents();
		}

		editHeadingLayout() {
			this.DOM.heading = this.DOM.el.querySelector('.heading--item');
			this.DOM.itemHeadingChars = Array.from(this.DOM.heading.querySelectorAll('.char'));
			wrapElements(this.DOM.itemHeadingChars, 'span', 'char-wrap');
		}

		initEvents() {
			this.DOM.enterAction.addEventListener('mouseenter', () => this.onMouseEnter());
			this.DOM.enterAction.addEventListener('mouseleave', () => this.onMouseLeave());
		}

		onMouseEnter() {
			if (window.innerWidth >= FXcurrentBreakpoint) {
				this.hoverTimeout = setTimeout(() => {
					if( this.timelineHoverOut ) this.timelineHoverOut.kill();

					this.timelineHoverIn = gsap.timeline()
						.addLabel('start', 0)
						// .to(this.DOM.enterAction, {
						// 	duration: 0.8,
						// 	ease: 'power3',
						// }, 'start')
						.to(this.image, {
							duration: 1,
							ease: 'power3',
							scale: 0.95
						}, 'start')
						.to(this.imageHelper, {
							duration: 1,
							ease: 'power3',
							scale: 1.1
						}, 'start')
						.to(this.DOM.itemHeadingChars, {
							duration: 0.2,
							ease: 'quad.in',
							x: this.invert ? '103%' : '-103%'
						}, 'start')
						.set(this.DOM.heading, {
							x: this.invert ? '10%' : '-10%',
						}, 'start+=0.2')
						.to(this.DOM.itemHeadingChars, {
							duration: 0.7,
							ease: 'expo',
							startAt: {x: this.invert ? '-103%' : '103%'},
							x: '0'
						}, 'start+=0.2');
				}, 10);
			}
		}

		onMouseLeave() {
			if (window.innerWidth >= FXcurrentBreakpoint) {
				if (this.hoverTimeout) {
					clearTimeout(this.hoverTimeout);
				}

				if( this.timelineHoverIn ) this.timelineHoverIn.kill();

				this.timelineHoverOut = gsap.timeline()
					.addLabel('start', 0)
					.to(this.DOM.enterAction, {
						duration: 0.8,
						ease: 'power3',
						x: 0,
						y: 0,
					}, 'start')
					.to(this.image, {
						duration: .7,
						ease: 'power3',
						scale: 1
					}, 'start')
					.to(this.imageHelper, {
						duration: .8,
						ease: 'power3',
						scale: 1
					}, 'start')
					.to(this.DOM.itemHeadingChars, {
						duration: 0.2,
						ease: 'quad.in',
						x: this.invert ? '-103%' : '103%',
					}, 'start')
					.set(this.DOM.heading, {
						x: '0',
					}, 'start+=0.2')
					.to(this.DOM.itemHeadingChars, {
						duration: 0.7,
						ease: 'expo',
						startAt: {x: this.invert ? '103%' : '-103%'},
						x: '0'
					}, 'start+=0.2');
			}
		}
	}

	let itemsArr = [];
	Array.from(document.querySelectorAll('.featured-pages-item')).forEach(item => itemsArr.push(new FXItem(item)));




	// Add gradient background to header
	let scrollTimeout;
	window.addEventListener('scroll', () => {

		if (scrollTimeout) {
			window.clearTimeout(scrollTimeout);
		}

		scrollTimeout = window.setTimeout(() => {
			let pageYOffset = window.pageYOffset || document.body.scrollTop;

			if (100 < pageYOffset) {
				document.querySelector('.with-bg-gradient').classList.add('active');
			} else {
				document.querySelector('.with-bg-gradient').classList.remove('active');
			}
		}, 200);
	});

	setTimeout(() => {
		window.dispatchEvent(new Event('resize'));
	}, 2000);

});


// (function($) {
//
// })(jQuery);
